import React from 'react';
import loadingGif from '../../assets/loader.gif'; 

const Loader = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <img src={loadingGif} alt="Loading..." className="h-32 w-32" />
    </div>
  );
};

export default Loader;
